import API from "../../helpers/API";
import {
    SHOW_LOADER,
    HIDE_LOADER,
    GET_INTERVIEW_MARKS_STATEMENT,
    GET_STATISTICAL_REPORT,
    SET_ALL_UNAPPROVAL_ENTITY_LIST,
    SET_UNAPPROVAL_PAGE_NO_COUNTER,
    SET_PRESENT_CANDIDATE_LIST,
    SET_MERITORIOUS_CANDIDATE_LIST,
    SET_INTERVIEWED_CANDIDATE_LIST,
    SET_QUALIFIED_CANDIDATE_LIST,
    SET_ADMITED_CANDIDATE_LIST,
} from "../../common/constants/ActionTypes";
import {
    GETINTERVIEWMARKSTATEMENT,
    GETSTATISTICALREPORT,
    INTREVIEW_MARKS_APPROVAL,
    ENTITYAPPROVALACTION,
    ENTITY_APPROVAL,
    GET_ADMITED_CANDIDATE_LIST,
    GET_QUALIFIED_CANDIDATE_LIST,
    GET_INTERVIEWED_CANDIDATE_LIST,
    GET_MERITORIOUS_CANDIDATE_LIST,
    GET_PRESENT_CANDIDATE_LIST,
} from "../../common/constants/endpoints";
import { toastr } from "react-redux-toastr";
import { handleError, handleResponseMessage } from "../../common/actions/commonActions";

export const showLoader = () => {
    return (dispatch) => {
        dispatch({
            type: SHOW_LOADER,
        });
    };
};

export const hideLoader = () => {
    return (dispatch) => {
        dispatch({
            type: HIDE_LOADER,
        });
    };
};


export const getInterviewMarkStatementByExamId = (examId) => {
    return async (dispatch) => {
        dispatch(showLoader());
        const session = JSON.parse(sessionStorage.getItem("session"));
        let token = session.jwtResponse && session.jwtResponse.token;
        try {
            let response = await API.get(`${GETINTERVIEWMARKSTATEMENT}/${examId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response) {
                handleResponseMessage(response);
                dispatch({
                    payload: response.data,
                    type: GET_INTERVIEW_MARKS_STATEMENT
                })
            }

            dispatch(hideLoader());

        } catch (error) {
            dispatch(hideLoader());
            handleError(error);
        }
    };
};


export const getStatisticalReportByExamId = (advtId, examId) => {
    return async (dispatch) => {
        dispatch(showLoader());
        const session = JSON.parse(sessionStorage.getItem("session"));
        let token = session.jwtResponse && session.jwtResponse.token;
        try {
            let response = await API.get(`${GETSTATISTICALREPORT}?advertisementid=${advtId}&examid=${examId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response) {
                dispatch({
                    payload: response.data,
                    type: GET_STATISTICAL_REPORT
                })
            }

            dispatch(hideLoader());

        } catch (error) {
            dispatch(hideLoader());
            handleError(error);
        }
    };
};

export const interviewMarksApprovalRequest = (examId, updatedValues) => {
    return async (dispatch) => {
        let response;
        try {
            const session = JSON.parse(sessionStorage.getItem("session"));
            let token = session.jwtResponse && session.jwtResponse.token;

            response = await API.post(`${INTREVIEW_MARKS_APPROVAL}/${examId}`, updatedValues, {
                headers: { Authorization: `Bearer ${token}` },
            });

            // dispatch({
            //     type: INTERVIEW_MARKS_DATA_UPDATED_SUCCESS,
            // });

            let successMessage =
                response && response.data ? response.data.message : response.message;
            toastr.success(successMessage);
        } catch (error) {
            handleError(error);
        }
    };
};


export const getAllApprovalInterviewMarksPagination = (
    pageNumber,
    rowPerPage
) => {
    return async function (dispatch) {
        const session = JSON.parse(sessionStorage.getItem("session"));
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(
                `${ENTITYAPPROVALACTION}/${pageNumber}/${rowPerPage}?entitytypes=interview_mark_list`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            let allDone = false;
            if (response) {

                if (response.data.approvalEmpty === true) {
                    dispatch({
                        type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
                        payload: {},
                    });
                }

                response &&
                    response.data &&
                    response.data.entityApprovalDtoList &&
                    response.data.entityApprovalDtoList.map((item, index) => {
                        let details =
                            item.entityApprovalAction &&
                            item.entityApprovalAction.entityApprovalDto &&
                            item.entityApprovalAction.entityApprovalDto.detail &&
                            JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
                        let parentdetails =
                            item.entityApprovalAction &&
                            item.entityApprovalAction.parentDetails &&
                            JSON.parse(item.entityApprovalAction.parentDetails);
                        response.data.entityApprovalDtoList[
                            index
                        ].entityApprovalAction.entityApprovalDto.detail = details;
                        response.data.entityApprovalDtoList[
                            index
                        ].entityApprovalAction.parentdetails = parentdetails;
                        if (index == response.data.entityApprovalDtoList.length - 1) {
                            allDone = true;
                        }
                        if (allDone) {
                            dispatch({
                                type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
                                payload: response.data,
                            });
                            dispatch({
                                type: SET_UNAPPROVAL_PAGE_NO_COUNTER,
                                payload: pageNumber * rowPerPage,
                            });
                        }
                    });
                handleResponseMessage(response);
            }
        } catch (error) {
            dispatch({
                type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
                payload: {},
            });
            handleError(error);
        }
    };
};


export const approvalEntityRequest = (requestData, setShowModal) => {
    return async (dispatch) => {
        const session = JSON.parse(sessionStorage.getItem("session"));
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(ENTITY_APPROVAL, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });

            setShowModal(false);
            dispatch(getAllApprovalInterviewMarksPagination(0, 10));

            if (response) {
                handleResponseMessage(response);
            }
            // let successMessage =
            //     response && response.data ? response.data.message : response.message;
            // toastr.success(successMessage);
        } catch (error) {
            handleError(error);
        }
    };
};

export const getAdmitedCandidates = (advtId, examId) => {
    return async (dispatch) => {
        dispatch(showLoader());
        const session = JSON.parse(sessionStorage.getItem("session"));
        let token = session.jwtResponse && session.jwtResponse.token;
        try {
            let response = await API.get(`${GET_ADMITED_CANDIDATE_LIST}?advertisementid=${advtId}&examid=${examId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response) {
                handleResponseMessage(response);
                dispatch({
                    payload: response.data.recommendedReportDto,
                    type: SET_ADMITED_CANDIDATE_LIST
                })
            }

            dispatch(hideLoader());

        } catch (error) {
            dispatch(hideLoader());
            handleError(error);
        }
    };
};

export const getQualifiedCandidates = (advtId, examId) => {
    return async (dispatch) => {
        dispatch(showLoader());
        const session = JSON.parse(sessionStorage.getItem("session"));
        let token = session.jwtResponse && session.jwtResponse.token;
        try {
            let response = await API.get(`${GET_QUALIFIED_CANDIDATE_LIST}?advertisementid=${advtId}&examid=${examId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response) {
                handleResponseMessage(response);
                dispatch({
                    payload: response.data.recommendedReportDto,
                    type: SET_QUALIFIED_CANDIDATE_LIST
                })
            }

            dispatch(hideLoader());

        } catch (error) {
            dispatch(hideLoader());
            handleError(error);
        }
    };
};

export const getInterviewedCandidates = (advtId, examId) => {
    return async (dispatch) => {
        dispatch(showLoader());
        const session = JSON.parse(sessionStorage.getItem("session"));
        let token = session.jwtResponse && session.jwtResponse.token;
        try {
            let response = await API.get(`${GET_INTERVIEWED_CANDIDATE_LIST}?advertisementid=${advtId}&examid=${examId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response) {
                handleResponseMessage(response);
                dispatch({
                    payload: response.data.recommendedReportDto,
                    type: SET_INTERVIEWED_CANDIDATE_LIST
                })
            }

            dispatch(hideLoader());

        } catch (error) {
            dispatch(hideLoader());
            handleError(error);
        }
    };
};

export const getMeritoriousCandidates = (advtId, examId) => {
    return async (dispatch) => {
        dispatch(showLoader());
        const session = JSON.parse(sessionStorage.getItem("session"));
        let token = session.jwtResponse && session.jwtResponse.token;
        try {
            let response = await API.get(`${GET_MERITORIOUS_CANDIDATE_LIST}?advertisementid=${advtId}&examid=${examId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response) {
                handleResponseMessage(response);
                dispatch({
                    payload: response.data.recommendedReportDto,
                    type: SET_MERITORIOUS_CANDIDATE_LIST
                })
            }

            dispatch(hideLoader());

        } catch (error) {
            dispatch(hideLoader());
            handleError(error);
        }
    };
};


export const getPresentCandidates = (advtId, examId) => {
    return async (dispatch) => {
        dispatch(showLoader());
        const session = JSON.parse(sessionStorage.getItem("session"));
        let token = session.jwtResponse && session.jwtResponse.token;
        try {
            let response = await API.get(`${GET_PRESENT_CANDIDATE_LIST}?advertisementid=${advtId}&examid=${examId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response) {
                handleResponseMessage(response);
                dispatch({
                    payload: response.data.recommendedReportDto,
                    type: SET_PRESENT_CANDIDATE_LIST
                })
            }

            dispatch(hideLoader());

        } catch (error) {
            dispatch(hideLoader());
            handleError(error);
        }
    };
};


export const interviewScheduleApprovalEntityRequest = (requestData, setShowModal) => {
    return async (dispatch) => {
        const session = JSON.parse(sessionStorage.getItem("session"));
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(ENTITY_APPROVAL, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });

            setShowModal(false);
            dispatch(getAllApprovalInterviewSchedulePagination(0, 10));

            if (response) {
                handleResponseMessage(response);
            }
            // let successMessage =
            //     response && response.data ? response.data.message : response.message;
            // toastr.success(successMessage);
        } catch (error) {
            handleError(error);
        }
    };
};

export const getAllApprovalInterviewSchedulePagination = (
    pageNumber,
    rowPerPage
) => {
    return async function (dispatch) {
        const session = JSON.parse(sessionStorage.getItem("session"));
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(
                `${ENTITYAPPROVALACTION}/${pageNumber}/${rowPerPage}?entitytypes=interview_schedule`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            let allDone = false;
            if (response) {

                if (response.data.approvalEmpty === true) {
                    dispatch({
                        type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
                        payload: {},
                    });
                }

                response &&
                    response.data &&
                    response.data.entityApprovalDtoList &&
                    response.data.entityApprovalDtoList.map((item, index) => {
                        let details =
                            item.entityApprovalAction &&
                            item.entityApprovalAction.entityApprovalDto &&
                            item.entityApprovalAction.entityApprovalDto.detail &&
                            JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
                        let parentdetails =
                            item.entityApprovalAction &&
                            item.entityApprovalAction.parentDetails &&
                            JSON.parse(item.entityApprovalAction.parentDetails);
                        response.data.entityApprovalDtoList[
                            index
                        ].entityApprovalAction.entityApprovalDto.detail = details;
                        response.data.entityApprovalDtoList[
                            index
                        ].entityApprovalAction.parentdetails = parentdetails;
                        if (index == response.data.entityApprovalDtoList.length - 1) {
                            allDone = true;
                        }
                        if (allDone) {
                            dispatch({
                                type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
                                payload: response.data,
                            });
                            dispatch({
                                type: SET_UNAPPROVAL_PAGE_NO_COUNTER,
                                payload: pageNumber * rowPerPage,
                            });
                        }
                    });
                handleResponseMessage(response);
            }
        } catch (error) {
            dispatch({
                type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
                payload: {},
            });
            handleError(error);
        }
    };
};